import { Routes, RouterModule } from '@angular/router';
import { PostsFeaturedResolver, PostsNewestResolver } from '@shared/resolvers/post.resolver';
import { InfoPagesComponent } from './info-pages.component';

const INFO_ROUTER: Routes = [
  {
    path: 'intro-creators',
    loadChildren: () =>
      import('./intro-creators/intro-creators.module').then((m) => m.IntroCreatorsModule),
    resolve: {
      featuredPosts: PostsFeaturedResolver,
    },
  },
  {
    path: 'intro-make-more-money',
    loadChildren: () =>
      import('./intro-make-more-money/intro-make-more-money.module').then(
        (m) => m.IntroMakeMoreMoneyModule
      ),
    resolve: {
      featuredPosts: PostsFeaturedResolver,
    },
  },
  {
    path: 'intro-short-form',
    loadChildren: () =>
      import('./intro-short-form/intro-short-form.module').then((m) => m.IntroShortFormModule),
    resolve: {
      featuredPosts: PostsFeaturedResolver,
    },
  },
  {
    path: '',
    component: InfoPagesComponent,
    children: [
      {
        path: 'creators',
        loadChildren: () => import('./creators/creators.module').then((m) => m.CreatorsInfoModule),
      },
      {
        path: 'embedding',
        loadChildren: () =>
          import('./embedding/embedding.module').then((m) => m.EmbeddingInfoModule),
      },
      {
        path: 'video-short-form-monetization',
        loadChildren: () =>
          import('./short-form-monetization/short-form-monetization.module').then(
            (m) => m.ShortFormMonetizationModule
          ),
        data: { hideSidebar: true },
      },
      {
        path: 'podcasters',
        loadChildren: () =>
          import('./podcast-monetization/podcast-monetization.module').then(
            (m) => m.PodcastMonetizationModule
          ),
        data: { hideSidebar: true },
      },
      {
        path: ':page',
        loadChildren: () => import('./content/content.module').then((m) => m.InfoContentModule),
      },
    ],
  },
];

export const infoPagesRouter = RouterModule.forChild(INFO_ROUTER);
